import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AOS from 'aos';
import { servicesData } from '../data/servicesData';
import { Helmet } from 'react-helmet-async';

function Services() {
  const { id } = useParams();
  const navigate = useNavigate();
  const service = servicesData.find(s => s.id === +id);

  useEffect(() => {
    if (!service) navigate('/');
  }, [service, navigate]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    AOS.init({
      duration: 700,
      easing: 'ease-out',
      once: true
    });
  }, []);

  if (!service) return null;

  console.log("service", service);
  return (
    <>
      <Helmet>
        <title>{service.title} | OnPoint Services</title>
        <meta
          name="description"
          content={`${service.title} by On Point Services. ${service.shortDesc}`}
        />
        <meta property="og:title" content={`${service.title} | On Point Services`} />
        <meta
          property="og:description"
          content={`${service.title} — ${service.shortDesc}. Serving Alabama, Florida, Georgia, and Tennessee.`}
        />
        <meta property="og:image" content={`${window.location.origin}${service.imgUrl}`} />
        <link
          rel="canonical"
          href={`https://www.on-point-services.com/services/${service.id}`}
        />
      </Helmet>
      <div className='services-details'>
        <div
          className="top-image mb-5"
          data-aos="zoom-in"
          data-aos-duration="1000"
        >
          <img
            src={service.imgUrl}
            alt={service.title}
            className="img-fluid w-100"
          />
        </div>

        <div className="container">
          <h1
            className="service-title text-center display-5 mb-4 poppins-medium"
            data-aos="fade-down"
            data-aos-delay="200"
          >
            {service.title}
          </h1>
          <p
            className="lead text-center mb-5"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            {service.fullDesc}
          </p>
        </div>
      </div>
    </>
  );
}

export default Services;
